import { render, staticRenderFns } from "./set-center-left.vue?vue&type=template&id=00baed40&scoped=true&"
import script from "./set-center-left.vue?vue&type=script&lang=js&"
export * from "./set-center-left.vue?vue&type=script&lang=js&"
import style0 from "./set-center-left.vue?vue&type=style&index=0&id=00baed40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00baed40",
  null
  
)

export default component.exports